import axiosClient from "./axiosClient";

const bannerApi = {
    /** Lấy banner active cho web */
    getActiveBanners() {
        return axiosClient.get("banner/active?target=web");
    },
};

export default bannerApi;
